import React from 'react'
import ProcessorModal from '.'

export default function ResetPriceModal({
  open = false,
  onClose = () => {},
  onSubmit = () => {},
  workflowType = 'manual',
}) {
  const isAutomated = workflowType === 'automated'

  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6 }}>
        <div className="dome-d-flex dome-flex-column dome-gap24">
          <div className="dome-d-flex dome-align-center dome-gap12">
            <span className="dome-d-flex dome-align-center ">
              <i style={{ fontSize: '42px' }} className="fa-thin fa-circle-check dome-color-dark-green"></i>
            </span>
            <span className="dome-h2 dome-color-dark-green">re-set price</span>
          </div>
          <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap24">
            <span className="dome-p2 dome-color-darkest-grey">
              An invoice has been sent to the requester, but payment has yet to be received.
            </span>
            {isAutomated && (
              <span className="dome-p2 dome-color-darkest-grey">
                Would you like to start processing this questionnaire while waiting for payment?
              </span>
            )}
          </div>
          <div className="dome-d-flex dome-justify-between">
            <button
              type="button"
              onClick={onClose}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-cancel"
            >
              close
            </button>
            {isAutomated && (
              <button type="button" onClick={onSubmit} className="dome-btn dome-btn-base dome-btn-dark-green">
                process form
              </button>
            )}
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
